import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IColorRectProps {
    hasOneColorCloseToWhite: boolean;
}

interface IColorSectionProps {
    hasOneColorCloseToWhite: boolean;
    backgroundColor?: string;
    first?: boolean;
    last?: boolean;
}
  
export const Root = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ControlContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    margin: 14px 0px 0px 0px;
    align-items: center;
`;

export const ColorContainer = styled.div`
    width: 100%;
`;

export const ColorRect = styled.div`
    display: flex;
    flex-direction: row;
    margin-left: auto; 
    margin-right: 0;
    width: ${(props: IColorRectProps) =>  props.hasOneColorCloseToWhite ? "32px" : "30px" };
    height: 30px;
    cursor: pointer;
`;

export const ColorSection = styled.div`
    height: 30px;
    width: 100%;
    background-color: ${(props: IColorSectionProps) => props.backgroundColor ?? "#000000"};
    border-top-left-radius: ${(props: IColorSectionProps) => props.first ? "5px":""};
    border-bottom-left-radius: ${(props: IColorSectionProps) => props.first ? "5px":""};
    border-top-right-radius: ${(props: IColorSectionProps) => props.last ? "5px":""};
    border-bottom-right-radius: ${(props: IColorSectionProps) => props.last ? "5px":""};
    border-top: ${(props: IColorSectionProps) =>  props.hasOneColorCloseToWhite ? "solid 2px #ccc" : "solid 0px" };
    border-bottom: ${(props: IColorSectionProps) =>  props.hasOneColorCloseToWhite ? "solid 2px #ccc" : "solid 0px" };
    border-left: ${(props: IColorSectionProps) =>  props.hasOneColorCloseToWhite && props.first ? "solid 2px #ccc" : "solid 0px" };
    border-right: ${(props: IColorSectionProps) =>  props.hasOneColorCloseToWhite && props.last ? "solid 2px #ccc" : "solid 0px" };
`;

export const LabelTitle = styled.span`
    margin: 3px 23px 3px 0;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #122442;
`;

export const PickerContainer = styled.div`
    width: 100%;
    display: flex;
    height: auto;
    flex-direction: column;
    flex-grow: 0;
    margin: 10px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    border-radius: 3px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    border: solid 1px #ccc;
`;

export const ColorSpacer = styled.div`
    margin: 0px 0px 0px 0px;
`;
